<mat-dialog-content class="mat-typography">
    <h3>Are you sure you want to delete this archive?</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">Cancel</button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">Yes</button>
</mat-dialog-actions>